<template lang="html">

  <form class="form form--trade" @submit="onSubmit">

    <div class="form__row">
      <div class="form__field">
        <input type="text" id="name" name="name" required value="" placeholder="Your name" v-model="enquiry.name">
        <div class="error" v-if="errors.name">{{ errors.name }}</div>
      </div>
    </div>

    <div class="form__row">
      <div class="form__field">
        <input type="tel" id="tel" name="tel" value="" required placeholder="Your phone number" v-model="enquiry.telephone">
        <div class="error" v-if="errors.telephone">{{ errors.telephone }}</div>
      </div>
    </div>


    <div class="form__row">
      <div class="form__field">
        <input type="email" id="email" name="email" value="" required placeholder="Your e-mail address" v-model="enquiry.email">
        <div class="error" v-if="errors.email">{{ errors.email }}</div>
      </div>
    </div>   

    <div class="form__row">
      <div class="form__field">
        <textarea name="enquiry" id="enquiry" rows="10" cols="80" placeholder="Any other information we might need" v-model="enquiry.message" required></textarea>
        <div class="error" v-if="errors.message">{{ errors.message }}</div>
      </div>
    </div>

    <file-pond
      name="files"
      ref="pond"
      :credits="false"
      label-idle="Drop files here..."
      :allow-multiple="true"
      :files="myFiles"
      server="/api/file_uploads"
    />

    <div class="form__submit">
      
      <button type="submit" name="submit" :disabled="isSending" class="button button--light-green">Submit Enquiry</button>
      <transition name="success">
        <span class="success-message" v-if="success">Your message has been sent</span>
      </transition>
    </div>
  </form>

</template>

<script>
import Api from "../utils/api";

// Import Vue FilePond
import vueFilePond from "vue-filepond";

// Import FilePond styles
import "filepond/dist/filepond.min.css";

const FilePond = vueFilePond();

export default {

  props: [
    'category',
    'title', 
    'date',
    'location', 
    'image',
    'url',
    'barbour'
  ],

  data: function() {
    return {
      enquiry: {
        name: '',
        telephone: '',
        email: '',
        message: '',
        barbour_email_id: this.barbour
      },
      errors: {},
      success: false,
      isSending: false,
      faded: false,
      myFiles: []
    }
  },
  
  methods: {
	  clearForm() {
			for (let field in this.enquiry) {
				this.enquiry[field] = ''
      }
      this.myFiles = []
      this.errors = {}
		},

		onSubmit(evt) {
			evt.preventDefault();

      this.isSending = true;

      this.enquiry.enquiry_file_ids = this.$refs.pond.getFiles().map(e => e.serverId)
      this.enquiry.enquiry_type = 'trade'
      
      Api.post('/enquiries', { enquiry: this.enquiry })
        .then((response) => {
          this.clearForm();
          this.isSending = false;
          this.success = true;
          this.faded = true;

          // Google Tag Manager event
          window.dataLayer.push({
            'event': 'form_submission',
            'form': {
              'form_id': 'trade',
              'form_name': 'Trade Enquiry'
            }
          });         

          setTimeout(() => {
            this.success = false;
            this.faded = false;
          }, 4000);
        }).catch((e) => {
          this.isSending = false;
          if (e.response && e.response.data.errors) {
            this.errors = e.response.data.errors;
          } else {
            alert("Sorry, something went wrong, please try again.")
          }
        });
	  	}
	}  
}
</script>

<style lang="scss">
  .success-message {
    padding-left: 20px;
    color: #5E285F;
  }

  .success-enter-active, .success-leave-active {
    transition: opacity .5s;
  }
  
  .success-enter, .success-leave-to {
    opacity: 0;
  }
</style>